const isObject = value =>
    value !== undefined && !Array.isArray(value) && typeof value === 'object';

export const flatten = (obj, parents = []) => Object.entries(obj)
    .reduce((o, [key, value]) => {
        if (isObject(value)) {
            return Object.assign(o, flatten(value, parents.concat(key)));
        } else {
            return Object.assign(o, {[parents.concat(key).join('.')]: value});
        }
    }, {});

const set = (obj, key, value) => {
    if (key.includes('.')) {
        const [k, ...rest] = key.split('.');
        return Object.assign(obj, {[k]: set(obj[k] || (obj[k] = {}), rest.join('.'), value)});
    } else return Object.assign(obj, {[key]: value});
}

export const expand = obj => Object.entries(obj)
    .reduce((o, [key, value]) => {
        return set(o, key, value);
    }, {});
